import { render, staticRenderFns } from "./Store_roomi.vue?vue&type=template&id=99ce5ace&scoped=true"
import script from "./Store_roomi.vue?vue&type=script&lang=js"
export * from "./Store_roomi.vue?vue&type=script&lang=js"
import style0 from "./Store_roomi.vue?vue&type=style&index=0&id=99ce5ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ce5ace",
  null
  
)

export default component.exports